<template>
    <flex-container
        align-content="center"
        justify-content="center"
        height="full"
    >
        <flex-container
            size="full"
            justify-content="center"
            :screen-sizes="{
                tablet: 5,
            }"
            gap="xl"
        >
            <flex-container
                :size="5"
                justify-content="center"
                :screen-sizes="{
                    tablet: 3,
                }"
            >
                <making-art-icon
                    :style="{ color: getCssColor('default', 'primary') }"
                />
            </flex-container>
            <flex-container
                size="full"
                :screen-sizes="{
                    tablet: 7,
                }"
                direction="column"
                gap="md"
            >
                <text-heading>
                    {{ t('heading') }}
                </text-heading>
                <text-description v-if="false">
                    {{ t('description') }}
                </text-description>
                <div>
                    <add-brand-button />
                </div>
            </flex-container>
        </flex-container>
    </flex-container>
</template>

<script setup lang="ts">
    import MakingArtIcon from '@/assets/icons/undraw/making_art.svg?component';
    import AddBrandButton from '@/company/brand/components/AddBrandButton.vue';
    import { getCssColor } from '@keyvue/one-ui';
    import { useI18n } from 'vue-i18n';
    import messages from './BrandCollectionEmptyMessage.messages.json';

    const { t } = useI18n({ messages });
</script>
